import React from "react";
import Slider from "../components/Slidbar/Slidbar";
import Tabel from "../components/Banner/Tabel";

export const Banner = () => {

  return (
    <>
      <Slider />
      <Tabel />
    </>
  );
};
